import React, { useState } from 'react';
import {
  Section,
  Container,
  TopRow,
  ContentSection,
  ViewAll,
  Title,
  Description,
  Grid,
  CategoryCard,
  CategoryImageWrapper,
  CategoryImage,
  CategoryPlaceholder,
  CategoryOverlay,
  CategoryArrow,
  CategoryName,
} from './Categories.styled';
import { CATEGORIES } from './constant';

const Categories = () => {
  const [imageErrors, setImageErrors] = useState({});
  const [imageLoaded, setImageLoaded] = useState({});

  const handleImageError = (slug) => {
    setImageErrors((prev) => ({ ...prev, [slug]: true }));
  };

  const handleImageLoad = (slug) => {
    setImageLoaded((prev) => ({ ...prev, [slug]: true }));
  };

  const containerVariants = {
    hidden: { opacity: 0 },
    visible: {
      opacity: 1,
      transition: {
        staggerChildren: 0.1,
      },
    },
  };

  const itemVariants = {
    hidden: { opacity: 0, y: 30 },
    visible: {
      opacity: 1,
      y: 0,
      transition: {
        duration: 0.6,
      },
    },
  };

  return (
    <Section>
      <Container>
        <TopRow>
          <Title
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true, amount: 0 }}
            transition={{ duration: 0.6, delay: 0.1 }}
          >
            CATEGORIES
          </Title>
          <ViewAll
            to="/products"
            initial={{ opacity: 0 }}
            whileInView={{ opacity: 1 }}
            viewport={{ once: true, amount: 0 }}
            transition={{ duration: 0.6, delay: 0.2 }}
          >
            view all
          </ViewAll>
        </TopRow>
        <ContentSection>
          <Description
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true, amount: 0 }}
            transition={{ duration: 0.6, delay: 0.3 }}
          >
            Browse through Swan’s complete range of reliable support
            solutions—built for strength and consistency.
          </Description>
        </ContentSection>
        <Grid
          variants={containerVariants}
          initial="hidden"
          whileInView="visible"
          viewport={{ once: true, amount: 0.1 }}
        >
          {CATEGORIES.map((category) => (
            <CategoryCard
              key={category.slug}
              variants={itemVariants}
              transition={{ type: 'spring', stiffness: 300, damping: 20 }}
              to={`/products/${category.slug}`}
              whileHover={{ scale: 1.02 }}
              whileTap={{ scale: 0.98 }}
            >
              <CategoryImageWrapper>
                {!imageErrors[category.slug] ? (
                  <CategoryImage
                    src={category.image}
                    alt={category.name}
                    onError={() => handleImageError(category.slug)}
                    onLoad={() => handleImageLoad(category.slug)}
                    loading="lazy"
                    style={{
                      opacity: imageLoaded[category.slug] ? 1 : 0,
                      transition: 'opacity 0.3s ease',
                    }}
                  />
                ) : null}
                {imageErrors[category.slug] && (
                  <CategoryPlaceholder>
                    {category.name.charAt(0)}
                  </CategoryPlaceholder>
                )}
                <CategoryOverlay
                  initial={{ opacity: 0 }}
                  whileHover={{ opacity: 1 }}
                  transition={{ duration: 0.3 }}
                >
                  <CategoryArrow
                    initial={{ x: -20, opacity: 0 }}
                    whileHover={{ x: 0, opacity: 1 }}
                    transition={{ duration: 0.3 }}
                  >
                    →
                  </CategoryArrow>
                </CategoryOverlay>
              </CategoryImageWrapper>
              <CategoryName>{category.name}</CategoryName>
            </CategoryCard>
          ))}
        </Grid>
      </Container>
    </Section>
  );
};

export default Categories;
